import { gql } from '@apollo/client';

export const WORKPLACE_EVENTS_QUERY = gql`
	query WorkplaceEvents(
		$start: DateTime
		$end: DateTime
		$types: [EventType]
		$workplaceIds: [UUID]
		$userIds: [UUID]
	) {
		workplaceEvents(
			start: $start
			end: $end
			types: $types
			workplaceIds: $workplaceIds
			userIds: $userIds
			pagination: { take: 9999 }
		) {
			data {
				id
				title
				dateFrom
				dateTo
				description
				type
				caseId
				description
				calendar {
					workplaceId
					workplace {
						name
						doctorDisplayName
					}
				}
				eventMembers {
					id
					userId
					user {
						id
						isPatient
						isDoctor
						isChild
						formattedPhoneNumber
						profile {
							fullName
							birthNumber
							age
						}
					}
					status
					role
				}
				layout
				meta {
					key
					value
				}
				createdBy {
					profile {
						fullName
					}
					isPatient
				}
			}
		}
	}
`;
